/**
 * @file Shared "outcome/result status" mapping used by both the script-builder
 * Result node (`features/mScripts/tessaScript/ScriptNode/ScriptNodeResult`) and
 * the Calendar/Daily overview outcome badge (`features/overview`).
 */

import type { FC, SVGProps } from 'react'
import { CheckCircle, XCircle, AlertCircle, HelpCircle } from '@untitledui/icons'

export type ResultStatus = 'successful' | 'unsuccessful' | 'followUp' | 'unknown'

export interface ResultStatusOption {
    value: ResultStatus
    labelKey: string
    icon: FC<SVGProps<SVGSVGElement>>
    /** Icon color matching Figma 343:1970 */
    iconColor: string
}

/**
 * Result statuses shown in the Outcome dropdown / rendered as outcome badges.
 */
export const RESULT_STATUSES: ResultStatusOption[] = [
    { value: 'successful', labelKey: 'SCRIPTS.NODE.RESULT_NODE.STATUS.SUCCESSFUL', icon: CheckCircle, iconColor: '#508030' },
    { value: 'unsuccessful', labelKey: 'SCRIPTS.NODE.RESULT_NODE.STATUS.UNSUCCESSFUL', icon: XCircle, iconColor: '#A0A0A0' },
    { value: 'followUp', labelKey: 'SCRIPTS.NODE.RESULT_NODE.STATUS.FOLLOW_UP', icon: AlertCircle, iconColor: '#F09020' },
    { value: 'unknown', labelKey: 'SCRIPTS.NODE.RESULT_NODE.STATUS.UNKNOWN', icon: HelpCircle, iconColor: '#B0B0B0' },
]

export const getResultStatusOption = (status?: ResultStatus | null): ResultStatusOption | undefined =>
    RESULT_STATUSES.find(option => option.value === status)
